import React from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from './theme/ThemeToggle';
import { useTheme } from './theme/ThemeContext';
import { useI18n } from '@/i18n';
import LanguageSwitch from '@/components/language/LanguageSwitch';
import { useAuth } from '@/components/auth/AuthContext';
import logoLight from '@/assets/logo_blue_norm.png';
import logoDark from '@/assets/logo_white_norm.png';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { t } = useI18n();
  const { user } = useAuth();

  return (
    <header className="app-header">
      <div className="left">
        <LanguageSwitch className="header-lang" mode={user ? 'user' : 'guest'} />
      </div>
      <div className="center">
        <div className="brand">
          <div
            role="button"
            tabIndex={0}
            aria-label={t('header.goHome')}
            onClick={() => navigate('/')}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('/');
              }
            }}
          >
            <div className="logo-stack">
              {/* Always render both logos; crossfade with CSS */}
              <img src={logoLight} alt={t('header.logoLightAlt')} className="logo-small logo-light" aria-hidden={theme === 'dark'} />
              <img src={logoDark} alt={t('header.logoDarkAlt')} className="logo-small logo-dark" aria-hidden={theme !== 'dark'} />
            </div>
          </div>
        </div>
      </div>
      <div className="right">
        <ThemeToggle />
      </div>
    </header>
  );
};

export default Header;
